<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.task.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.task.line-1") }}
            </p>

            <p class="mt-3 mb-3">{{ $t("help.platform.task.line-2") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.task.line-3") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.task.line-4") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.task.line-5") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.task.line-6") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.task.new.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.task.new.line-1") }}
              </p>

              <img src="@/assets/images/help/new-task.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.task.new.line-2')"></p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.task.edit.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.task.edit.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/task-edit.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.task.edit.line-2')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.task.edit.line-3')"></p>
              <p class="mb-3">
                {{ $t("help.platform.task.edit.line-4") }}
              </p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.task.edit.line-5')"></p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.task.list.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.task.list.line-1") }}
              </p>
              <img src="@/assets/images/help/task-view-button.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.task.list.line-2") }}</p>
              <img src="@/assets/images/help/kanban.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.task.list.line-3") }}</p>
              <img src="@/assets/images/help/task-list-view.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.task.list.line-4") }}</p>
              <img src="@/assets/images/help/my-task.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.task.list.line-5") }}</p>
              <img src="@/assets/images/help/organization-task.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.task.list.line-6") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.task.list.line-7") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.task.archive.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.task.archive.line-1") }}
              </p>
              <p class="mb-3">
                {{ $t("help.platform.task.archive.line-2") }}<img src="@/assets/images/help/task-archive-button.png" class="image d-inline ml-2" />
                {{ $t("help.platform.task.archive.line-3") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
